import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { HelpArticlesProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { Loader } from './loader.routes';

const HelpArticlesList = Loader(lazy(() => import('../pages/HelpArticles/HelpArticlesList')));

export const createHelpArticlesRoutes = () => ({
  path: 'help-articles',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: <Navigate to="/help-articles/list" replace />
    },
    {
      path: 'list',
      element: (
        <HelpArticlesProvider>
          <HelpArticlesList />
        </HelpArticlesProvider>
      )
    }
  ]
});
